import React from "react";
import { ArrowLeft, Plus, Users } from "lucide-react";

const ShopManageHeader = ({ onBack, onInviteMember, onAddAdmin, shopId }) => {
  return (
    <header className="shop-manage-header mt-5">
      <button
        className="shop-back-button"
        type="button"
        onClick={onBack}
        aria-label="Go back"
      >
        <ArrowLeft size={18} />
        <span>Back</span>
      </button>

      <div className="shop-manage-heading">
        <div className="shop-manage-title-icon">
          <Users size={22} />
        </div>
        <div>
          <h4>Manage your team</h4>
          <p>Manage the people who have access to your shop.</p>
        </div>
      </div>

      <div className="shop-header-actions">
        <button
          type="button"
          className="shop-button shop-button-primary"
          disabled={!shopId}
          onClick={onInviteMember}
        >
          <Plus size={18} />
          Add Admin
        </button>
      </div>
    </header>
  );
};

export default ShopManageHeader;
